import {
    REQUEST_CONNECT_USER,
    RECEIVE_CONNECT_USER,
    FAIL_CONNECT_USER
} from '../actions';
import Routes from '../constants/Routes';

const defaultState = {
    auth: null,
    isRequestingUser: false,
    err: null,
    nextPage: null,
    createConfirm: null
};

const signupReducer = (state = defaultState, action) => {
    switch (action.type) {
        case REQUEST_CONNECT_USER:
            return {
                ...state,
                isRequestingUser: action.isRequestingUser,
                auth: null,
                err: null
            };
        case RECEIVE_CONNECT_USER:
            return {
                ...state,
                auth: action.json,
                isRequestingUser: false,
                err: null,
                nextPage: Routes.REGISTRATION.SSO_CONFIRM,
                createConfirm: true
            };
        case FAIL_CONNECT_USER:
            return {
                ...state,
                err: action.error,
                isRequestingUser: false,
                auth: null
            };
        default:
            return state;
    }
};

export default signupReducer;
